module.exports = __webpack_public_path__ + "static/media/arrow-back.94a6505a.svg";